import { NormalisedNode } from 'v2/querybuilder/types/querystore';

export function isEmptyQuery(rootNode?: NormalisedNode): boolean {
  return !rootNode?.children?.length;
}
